import React, { useEffect, useState } from 'react';
import './styles.css';
import { useLocation, useNavigate } from 'react-router-dom';

type BreadcrumbItem = { label: string; link: string };

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

const BreadcrumbSeparator: React.FC = () => {
  return <span className="breadcrumb-separator">{'>'}</span>;
};

const Breadcrumb: React.FC<BreadcrumbProps> = ({ items }) => {
  const navigate = useNavigate();
  return (
    <div className="breadcrumb-container">
      <nav aria-label="breadcrumb-nav">
        <ol className="breadcrumb">
          {items.map((item, index) => (
            <li
              key={index}
              className={`breadcrumb-item ${
                index === items.length - 1 ? 'active' : ''
              }`}
            >
              <span
                className={`breadcrumb-item-label`}
                onClick={() => {
                  navigate(`${item.link}`);
                }}
              >
                {item.label}
              </span>
              {index !== items.length - 1 && <BreadcrumbSeparator />}
            </li>
          ))}
        </ol>
      </nav>
    </div>
  );
};

const BreadcrumbRouter = () => {
  const breadcrumbData: BreadcrumbItem[] = [
    { label: 'Home', link: `/` },
    { label: 'Tools', link: `/tools` },
    { label: 'Cartaz', link: `/tools/banner` },
    { label: 'Cartazes', link: `/tools/banner/files` },
    { label: 'Promoções', link: `/tools/banner/promotions` },
    { label: 'Layouts', link: `/tools/banner/layouts` },
    {
      label: 'Configurações',
      link: `/tools/banner/configurations`,
    },
    { label: 'Preço', link: `/tools/price` },
    { label: 'Etiquetas', link: `/tools/ticket` },
    {
      label: 'Preços offline',
      link: `/tools/ticket/offline-prices`,
    },
    { label: 'Exportações', link: `/tools/exports` },
    { label: 'Invoices', link: `/tools/exports/invoices` },
    { label: 'Taxas', link: `/tools/exports/taxes` },
    { label: 'Companhias', link: `/tools/exports/companies` },
    { label: 'Depósitos', link: `/tools/exports/deposits` },
    { label: 'Logística', link: `/tools/exports/logistic` },
    { label: 'Validades', link: `/tools/validity` },
    { label: 'Validades', link: `/tools/validity/validities` },
    { label: 'Status', link: `/tools/validity/status` },
  ];

  const [breadcrumbItems, setBreadcrumbItems] = useState<BreadcrumbItem[]>([]);
  const location = useLocation();
  const pathname = location.pathname;

  useEffect(() => {
    setBreadcrumbItems(
      pathname
        .replace('/', '')
        .split('/')
        .reduce(
          (acc, acv, currentIndex) => {
            const lastRoute = acc[acc.length - 1];
            const currentLink = `${lastRoute.link}${
              currentIndex === 0 ? '' : '/'
            }${acv}`;
            const currentRoute = breadcrumbData.find(
              ({ link }) => link === currentLink,
            )!;
            return [...acc, currentRoute];
          },
          [{ label: 'Home', link: `/` }] as BreadcrumbItem[],
        ),
    );
  }, [pathname]);

  return <Breadcrumb items={breadcrumbItems} />;
};

export default Object.assign(Breadcrumb, {
  Router: BreadcrumbRouter,
});
